export function SparklesIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox='0 0 24 24' {...props}>
			<path
				fill='currentColor'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.5 4c0 5.247 3.358 9.5 7.5 9.5-4.142 0-7.5 4.253-7.5 9.5 0-5.247-3.358-9.5-7.5-9.5 4.142 0 7.5-4.253 7.5-9.5M16.5 1c0 2.485 1.567 4.5 3.5 4.5-1.933 0-3.5 2.015-3.5 4.5 0-2.485-1.567-4.5-3.5-4.5 1.933 0 3.5-2.015 3.5-4.5'
			/>
		</svg>
	);
}
